import {Component, Inject, OnInit, ViewEncapsulation} from '@angular/core';
import {MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import {SynchronizationService} from '../../../services/synchronization.service';
import {OAuth2Service} from '../../../services/o-auth2.service';
import { TranslateService } from '@ngx-translate/core';



@Component({
  selector:  'app-userprofiledialog',
  templateUrl: './userprofiledialog.component.html',
  styleUrls: ['./userprofiledialog.component.scss'],
  encapsulation: ViewEncapsulation.None
  })


export class UserprofiledialogComponent  implements OnInit  {

  public logoutText: string;

  constructor(@Inject(MAT_DIALOG_DATA) public data: any,
    private synchronizationService: SynchronizationService,
    protected translateService: TranslateService,
    private oAuth2Service: OAuth2Service) { }

  ngOnInit(): void {
    this.translateService.get('components.userProfile.logout').subscribe(result => {
      this.logoutText = result;
    });
  }
  logout() {
    this.synchronizationService.sendEvent('loggedOut', this.data.user);
    this.oAuth2Service.Logout();
  }
}
